__webpack_require__.p = "https://3d-render-bgo.pages.dev/";